import "./App.css";
import { Link } from "react-router-dom";

function Expenseo() {
  return (
    <div className="App">
      <div className="top">
        <div className="content">
          <span className="title">Expenseo: Budget Manager</span>
          <p className="desc" style={{ textAlign: "center" }}>
            Easiest way to manage your expenses. Budgeting made simple.
          </p>
          <div className="btns" style={{ color: "white" }}>
            Support mail:{" "}
            <a href="mailto:contact@charles-zimmerlin.com">
              contact@charles-zimmerlin.com
            </a>
          </div>
        </div>{" "}
      </div>
      <footer>
        <Link className="footerA" to="/confidentiality-budget">
          Privacy Policy
        </Link>
        <span className="footerText">
          {" "}
          Copyright ©{new Date().getFullYear()}
        </span>
        <a
          className="footerA"
          href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
        >
          EULA
        </a>
      </footer>
    </div>
  );
}

export default Expenseo;
